import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Sentry from 'Integrations/Sentry';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/Styles';
import Button1 from 'Components/ComponentLibrary/Components/Buttons/Button1';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import history from 'State/history';
import { dashboardUri } from 'Consts/clientUris';

const styles = () => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  reloadButton: {},
  errorStackTrace: {},
});

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/no-unused-state
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError() {
    // this function takes an error as a arg, we could pull a message out of the error to display to a user
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      // eslint-disable-next-line react/no-unused-state
      error,
      // eslint-disable-next-line react/no-unused-state
      errorInfo,
    });

    Sentry.createSentryErrorLog(error);
  }

  render() {
    const { hasError } = this.state;
    const {
      classes,
      className,
      children,
    } = this.props;

    if (hasError) {
      return (
        <Box className={classNames(className, classes.root)}>
          <Typography>
            {'An error has occurred.'}
          </Typography>
          <Button1
            className={classes.reloadButton}
            color={'primary'}
            disableElevation
            variant={'contained'}
            onClick={() => {
              history.push(dashboardUri);
            }}
          >
            {'Reload'}
          </Button1>
        </Box>
      );
    }

    return children;
  }
}

ErrorBoundary.defaultProps = {
  className: '',
};

ErrorBoundary.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.any.isRequired,
};

export default withStyles(styles)(ErrorBoundary);
